import { createSlice } from '@reduxjs/toolkit';

const defaultOpacity = 0.8;

const slice = createSlice({
  name: 'score',
  initialState: {
    afforeforestationOpacity: defaultOpacity,
    reddOpacity: defaultOpacity,
    revegetationOpacity: defaultOpacity,
  },
  reducers: {
    setAfforeforestationOpacity: (state, action) => {
      state.afforeforestationOpacity = action.payload;
    },
    setReddOpacity: (state, action) => {
      state.reddOpacity = action.payload;
    },
    setRevegetationOpacity: (state, action) => {
      state.revegetationOpacity = action.payload;
    },
  },
});

export default slice.reducer;

export const setAfforeforestationOpacity = (payload) => ({ type: 'score/setAfforeforestationOpacity', payload });
export const setReddOpacity = (payload) => ({ type: 'score/setReddOpacity', payload });
export const setRevegetationOpacity = (payload) => ({ type: 'score/setRevegetationOpacity', payload });
